document.addEventListener('DOMContentLoaded', function () {
    var sleep = 2500;
    var productGridContainer = document.querySelector('.product-grid-container');
    var isInitialLoad = true;
    var pendingHandleTimeout = null;

    if (!productGridContainer) return;

    function isScrolledToBottom() {
        var containerRect = productGridContainer.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return containerRect.bottom <= windowHeight;
    }

    function showElements(count) {
        var elementsToShow = document.querySelectorAll('.scroll-infinite.d-none');
        for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
            elementsToShow[i].classList.remove('d-none');
        }
    }

    function handleEvent() {
        if (isInitialLoad) return;
        if (pendingHandleTimeout) {
            clearTimeout(pendingHandleTimeout);
        }
        pendingHandleTimeout = setTimeout(() => {
            if (!document.querySelector('.scroll-infinite.d-none')) return;
            showElements(show_first);
            pendingHandleTimeout = null;
        }, sleep);
    }

    function countElements() {
        var elementsCount = document.querySelectorAll('.product-grid-container .scroll-infinite').length;
        if (document.querySelector("#ProductCountDesktop")) {
            document.querySelector("#ProductCountDesktop").innerHTML = elementsCount + " productos";
        }
        if (document.querySelector("#ProductCount")) {
            document.querySelector("#ProductCount").innerHTML = elementsCount + " productos";
        }
    }

    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if (!isInitialLoad) {
                    handleEvent();
                }
            }
        }
    });

    var observerConfig = { childList: true, subtree: true };
    observer.observe(productGridContainer, observerConfig);

    function initializeScript() {
        observer.disconnect();

        document.addEventListener('scroll', function () {
            if (isScrolledToBottom() && document.querySelector('.scroll-infinite.d-none')) {
                showElements(show_first);
            }
        }, { passive: true });

        // Delegación para evitar re-bind en nodos reemplazados por filtros AJAX.
        document.addEventListener('click', function (event) {
            if (
                event.target.closest('input[type="checkbox"]') ||
                event.target.closest('.active-facets__button-remove')
            ) {
                handleEvent();
            }
        });

        document.addEventListener('change', function (event) {
            if (event.target.matches('#SortBy, #SortBy-mobile, #SortBy-mobile-bar, select[name="sort_by"]')) {
                handleEvent();
            }
        });

        showElements(show_first);
        checkProductQty();
        isInitialLoad = false;

        observer.observe(productGridContainer, observerConfig);
        
        countElements();
    }

    initializeScript();
});
